import { useState } from "react";
import { hotItems } from "@/mocks/news";

const trendIcon = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-500" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

export default function HotRanking() {
  const [range, setRange] = useState<"daily" | "weekly">("daily");
  const list = hotItems.filter((item) => (range === "daily" ? item.daily : true));

  return (
    <section id="hot" className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-fire-fill text-primary-500"></i>
          热门榜单
        </h2>
      </div>

      <div className="mt-4 flex gap-1 rounded-full border border-background-200 bg-background-100 p-1">
        {([
          { key: "daily", label: "今日榜" },
          { key: "weekly", label: "本周榜" },
        ] as const).map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setRange(tab.key)}
            className={`flex-1 cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
              range === tab.key
                ? "bg-background-50 font-medium text-primary-700 shadow-none"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <ol className="mt-4 divide-y divide-background-200">
        {list.map((item) => (
          <li key={item.id}>
            <a
              href="#live"
              className="group flex cursor-pointer items-start gap-3 py-3 transition-colors hover:bg-background-100/70"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  item.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                }`}
              >
                {item.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-900">{item.tag}</span>
                  {item.heat}
                </span>
              </span>
              <i className={`${trendIcon[item.trend].icon} ${trendIcon[item.trend].color} mt-1 text-base`}></i>
            </a>
          </li>
        ))}
      </ol>
    </section>
  );
}